import { mapActions, mapGetters} from 'vuex'

export default {
    methods: { 
        ...mapActions(["setLoader"])
    },
    computed: {
        ...mapGetters(["getLoader"])
    }
}